import { render, staticRenderFns } from "./ReactMountLerReceita.vue?vue&type=template&id=56e41ec7&scoped=true"
import script from "./ReactMountLerReceita.vue?vue&type=script&lang=ts"
export * from "./ReactMountLerReceita.vue?vue&type=script&lang=ts"
import style0 from "./ReactMountLerReceita.vue?vue&type=style&index=0&id=56e41ec7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e41ec7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e41ec7')) {
      api.createRecord('56e41ec7', component.options)
    } else {
      api.reload('56e41ec7', component.options)
    }
    module.hot.accept("./ReactMountLerReceita.vue?vue&type=template&id=56e41ec7&scoped=true", function () {
      api.rerender('56e41ec7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountLerReceita.vue"
export default component.exports